import { 
  Box, Typography , List, ListItem, ListItemIcon
} from '@material-ui/core';

import ApartmentIcon from '@material-ui/icons/Apartment';
import PersonIcon from '@material-ui/icons/Person';

import { Apartment } from '../../../graphql/models';

export interface ApartmentBoxPreviewProps {
  apartment: Apartment
}

export function ApartmentBoxPreview(props: ApartmentBoxPreviewProps) {
  const { apartment } = props;

  return (
    <Box component="li">
      <List
        component='nav'
        aria-labelledby={`apartment-${apartment?.id}-data-list-subheader`}
        style={{width: '100%'}}
      >
        <ListItem>
          <ListItemIcon>
            <ApartmentIcon />
          </ListItemIcon>
          <Typography
            variant='caption'
          >
            {apartment.building.name} - Appartamento {apartment.code}
            {apartment.name && (
              <>
                <br /> {apartment.name}
              </>
            )}
          </Typography>
        </ListItem>
        {apartment.owner && (
          <ListItem>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <Typography
              variant='caption'
            >
              Proprietario: {apartment.owner.name} ({apartment.owner.phone})
            </Typography>
          </ListItem>
        )}
      </List>
    </Box>
  )
}